var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentimentVeryDissatisfiedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.167 91.6667C136.07 91.6667 141.667 86.0702 141.667 79.1667C141.667 72.2631 136.07 66.6667 129.167 66.6667C122.263 66.6667 116.667 72.2631 116.667 79.1667C116.667 86.0702 122.263 91.6667 129.167 91.6667Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8333 91.6667C77.7368 91.6667 83.3333 86.0702 83.3333 79.1667C83.3333 72.2631 77.7368 66.6667 70.8333 66.6667C63.9297 66.6667 58.3333 72.2631 58.3333 79.1667C58.3333 86.0702 63.9297 91.6667 70.8333 91.6667Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9167 16.6667C53.9167 16.6667 16.6667 54 16.6667 100C16.6667 146 53.9167 183.333 99.9167 183.333C146 183.333 183.333 146 183.333 100C183.333 54 146 16.6667 99.9167 16.6667ZM100 166.667C63.1667 166.667 33.3334 136.833 33.3334 100C33.3334 63.1667 63.1667 33.3333 100 33.3333C136.833 33.3333 166.667 63.1667 166.667 100C166.667 136.833 136.833 166.667 100 166.667ZM100 116.667C84.1667 116.667 69.7501 124.75 61.2501 138.167C59.4167 141.083 60.3334 144.917 63.2501 146.75C66.1667 148.583 70.0001 147.667 71.8334 144.75C78.0001 134.917 88.5001 129.083 100 129.083C111.5 129.083 122 134.917 128.167 144.75C129.333 146.667 131.417 147.667 133.5 147.667C134.667 147.667 135.75 147.333 136.833 146.75C139.75 144.917 140.667 141.083 138.833 138.167C130.25 124.667 115.833 116.667 100 116.667Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentVeryDissatisfiedIcon);
export default __webpack_public_path__ + "static/media/SentimentVeryDissatisfiedIcon.45d342ea186289bebdf8e33a74a223de.svg";
export { ForwardRef as ReactComponent };